"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOneSelectedFolder = exports.getOneSelectedFile = exports.getNewFilename = exports.getIsAnySelected = exports.getFolderTree = exports.getCurrentFolderData = exports.getCurrentFolder = exports.getBreadcrumbs = exports.getAllFiles = void 0;
var _reselect = require("reselect");
var _config = require("../config.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getTopFolderId = function getTopFolderId(state) {
  return state.topFolderId;
};
var getCurrentFolderId = function getCurrentFolderId(state) {
  return state.currentFolderId;
};
var getFolders = function getFolders(state) {
  return state.folders;
};
var getFiles = function getFiles(state) {
  return state.files;
};
var getSelectedFiles = function getSelectedFiles(state) {
  return state.selectedFiles;
};
var getSelectedFolders = function getSelectedFolders(state) {
  return state.selectedFolders;
};
var getSelectedFolderUp = function getSelectedFolderUp(state) {
  return state.selectedFolderUp;
};
var getSortBy = function getSortBy(state) {
  return state.sortBy;
};
var getGlobalFilter = function getGlobalFilter(state) {
  return state.globalFilter;
};
var getFilter = function getFilter(state) {
  return state.filter;
};
var getLoadedFolders = function getLoadedFolders(state) {
  return state.loadedFolders;
};
var getCurrentFolderData = exports.getCurrentFolderData = (0, _reselect.createSelector)(getCurrentFolderId, getFolders, getFiles, getSortBy, getGlobalFilter, getFilter, function (currentFolderId, folders, files, sortBy, globalFilter, filter) {
  var sortByName = function sortByName(a, b) {
    return a.name.localeCompare(b.name);
  };
  var sortByNewest = function sortByNewest(a, b) {
    return b.updatedAt.localeCompare(a.updatedAt);
  };
  return {
    folders: folders.filter(function (item) {
      return item.parentId === currentFolderId && item.path !== "/".concat(_config.TRASH_FOLDER_NAME);
    }).sort(sortByName),
    files: files.filter(function (item) {
      var result = item.folderId === currentFolderId;
      var regex = (_config.globalFilters[globalFilter] || {}).regex;
      if (regex) {
        result = result && regex.test(item.name.toLowerCase());
      }
      if (filter) {
        result = result && item.name.toLowerCase().includes(filter.toLowerCase());
      }
      return result;
    }).map(function (item) {
      if (item.thumbnailSmall) {
        return item;
      }
      var extension = (item.name.match(/\.([^.]+)$/) || ['', ''])[1];
      if (!_config.typeThumbnails[extension]) {
        return item;
      }
      var thumbnailSmall = process.env.NODE_ENV === 'test' ? 'mock' : _config.typeThumbnails[extension];
      return _objectSpread(_objectSpread({}, item), {}, {
        thumbnailSmall: thumbnailSmall,
        thumbnailLarge: thumbnailSmall
      });
    }).sort(sortBy === 'filename' ? sortByName : sortByNewest)
  };
});
var getCurrentFolder = exports.getCurrentFolder = (0, _reselect.createSelector)(getTopFolderId, getCurrentFolderId, getFolders, function (topFolderId, currentFolderId, folders) {
  return topFolderId === currentFolderId ? {
    id: currentFolderId,
    path: ''
  } : folders.find(function (item) {
    return item.id === currentFolderId;
  });
});
var getBreadcrumbs = exports.getBreadcrumbs = (0, _reselect.createSelector)(getTopFolderId, getCurrentFolderId, getFolders, function (topFolderId, currentFolderId, folders) {
  var result = [];
  var _addFolder = function addFolder(id) {
    if (id === topFolderId) {
      result.push({
        id: topFolderId,
        name: 'Assets'
      });
      return;
    }
    var folder = folders.find(function (item) {
      return item.id === id;
    });
    result.push({
      id: id,
      name: folder.name
    });
    _addFolder(folder.parentId);
  };
  _addFolder(currentFolderId);
  return result.reverse();
});
var getOneSelectedFile = exports.getOneSelectedFile = (0, _reselect.createSelector)(getSelectedFiles, getSelectedFolders, getFiles, function (selectedFiles, selectedFolders, files) {
  if (selectedFiles.length !== 1 || selectedFolders.length !== 0) {
    return null;
  }
  return files.find(function (item) {
    return item.id === selectedFiles[0];
  }) || null;
});
var getOneSelectedFolder = exports.getOneSelectedFolder = (0, _reselect.createSelector)(getSelectedFiles, getSelectedFolders, getFolders, function (selectedFiles, selectedFolders, folders) {
  if (selectedFolders.length !== 1 || selectedFiles.length !== 0) {
    return null;
  }
  return folders.find(function (item) {
    return item.id === selectedFolders[0];
  }) || null;
});
var getIsAnySelected = exports.getIsAnySelected = (0, _reselect.createSelector)(getOneSelectedFile, getOneSelectedFolder, getSelectedFolderUp, function (selectedFile, selectedFolder, selectedFolderUp) {
  return selectedFile || selectedFolder || selectedFolderUp;
});
var getFolderTree = exports.getFolderTree = (0, _reselect.createSelector)(getTopFolderId, getFolders, getLoadedFolders, function (topFolderId, folders, loadedFolders) {
  var _getChildren = function getChildren(parentId) {
    return folders.filter(function (item) {
      return item.parentId === parentId && item.path !== "/".concat(_config.TRASH_FOLDER_NAME);
    }).map(function (item) {
      return {
        id: item.id,
        name: item.name,
        loaded: loadedFolders.includes(item.id),
        children: _getChildren(item.id)
      };
    });
  };
  return [{
    id: topFolderId,
    name: 'Assets',
    loaded: true,
    children: _getChildren(topFolderId)
  }];
});
var getAllFiles = exports.getAllFiles = (0, _reselect.createSelector)(getTopFolderId, getFiles, getFolders, function (topFolderId, files, folders) {
  return files.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      path: item.folderId === topFolderId ? '/' + item.name : folders.find(function (folder) {
        return folder.id === item.folderId;
      }).path + '/' + item.name
    });
  });
});
var getNewFilename = exports.getNewFilename = (0, _reselect.createSelector)(getOneSelectedFile, getAllFiles, function (selectedFile, allFiles) {
  var allFilenames = new Set(allFiles.filter(function (item) {
    return item.folderId === selectedFile.folderId;
  }).map(function (item) {
    return item.name;
  }));
  var parts = selectedFile.name.split('.');
  var name = parts.slice(0, parts.length - 1).join('.');
  var extension = parts[parts.length - 1];
  var counter = 1;
  var newName;
  do {
    newName = "".concat(name).concat(counter++, ".").concat(extension);
  } while (allFilenames.has(newName));
  return newName;
});